module.exports = __webpack_public_path__ + "img/ic-discover.f6bf801.gif";